export default __webpack_public_path__ + "static/logo-ab6538dd1338f8f289d8b64b714311c7.png";